/*
 * Nysta PDP gallery: later slides load when they are needed (2026-09-28, performance).
 *
 * snippets/product-media.liquid (defer_src) renders slides 2..n with a blank placeholder and the
 * real sources in data-nysta-src / data-nysta-srcset. Without this, `loading=lazy` still fetched
 * them at once (they sit next to slide 1, inside the lazy-load distance) and they took bandwidth
 * from the first, largest-contentful image.
 *
 * The sources are set:
 *   - once the first gallery image has loaded (then at idle), or
 *   - at once when the customer interacts with the gallery (pointer, touch, keys, wheel, focus,
 *     scrolling the slides), or
 *   - after 8 s at the latest.
 * Slides re-rendered later (variant change morphs the section) are filled in immediately once the
 * gallery has been released.
 */
(() => {
  if (window.__nystaGalleryDefer) return;
  window.__nystaGalleryDefer = true;

  /** @param {ParentNode} root */
  const hydrate = (root) => {
    root.querySelectorAll('img[data-nysta-srcset], img[data-nysta-src]').forEach((img) => {
      if (img.dataset.nystaSrcset) img.srcset = img.dataset.nystaSrcset;
      if (img.dataset.nystaSrc) img.src = img.dataset.nystaSrc;
      img.removeAttribute('data-nysta-srcset');
      img.removeAttribute('data-nysta-src');
    });
  };

  /** @param {HTMLElement} gallery */
  const setup = (gallery) => {
    if (gallery.dataset.nystaDeferReady) return;
    gallery.dataset.nystaDeferReady = 'true';
    let released = false;
    const release = () => {
      if (released) return;
      released = true;
      hydrate(gallery);
      new MutationObserver(() => hydrate(gallery)).observe(gallery, { childList: true, subtree: true });
    };
    const whenIdle = () => ('requestIdleCallback' in window ? requestIdleCallback(release, { timeout: 1500 }) : setTimeout(release, 200));
    const first = gallery.querySelector('.product-media__image:not([data-nysta-srcset])');
    if (!first || (first.complete && first.naturalWidth > 0)) whenIdle();
    else {
      first.addEventListener('load', whenIdle, { once: true });
      first.addEventListener('error', whenIdle, { once: true });
    }
    for (const type of ['pointerdown', 'touchstart', 'keydown', 'wheel', 'focusin']) {
      gallery.addEventListener(type, release, { once: true, passive: true });
    }
    gallery.querySelectorAll('slideshow-slides').forEach((s) => s.addEventListener('scroll', release, { once: true, passive: true }));
    setTimeout(release, 8000);
  };

  const init = () => document.querySelectorAll('.nysta-product-media').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
